import { WaterTreatmentPlantIcon } from '../icons'

export default {
  id: 'water-treatment-plants',
  Icon: WaterTreatmentPlantIcon,
  title: {
    en: 'Water Treatment Plants',
    ar: 'محطات معالجة المياه'
  },
  description: {
    en: `<p>Water treatment is a process that improves the quality of water to make it more acceptable for a specific end-use.</p><p>Treated water may be used for drinking, industrial water supply, irrigation, river flow maintenance, recreation, or is safely returned to the environment.</p>`,
    ar: ``
  },
  entries: [
    {
      id: 'wtp01',
      position: { x: 367, y: 365 },
      title: { en: 'Kufranja', ar: 'كفرنجة' },
      year: '2018',
      capacity: '120'
    },
    {
      id: 'wtp02',
      position: { x: 406.0, y: 682.0 },
      title: { en: 'Mujib', ar: 'الموجب' },
      year: '2015',
      capacity: '500'
    },
    {
      id: 'wtp03',
      position: { x: 361, y: 243 },
      title: { en: 'WadiAl-Arab', ar: 'وادي العرب' },
      year: '1982',
      capacity: '2400'
    },
    {
      id: 'wtp04',
      position: { x: 157.0, y: 1374.0 },
      title: { en: 'Aqaba Desalination Plant', ar: 'العقبة' },
      year: '2000-2017',
      capacity: '500'
    },
    {
      id: 'wtp05',
      position: { x: 405.0, y: 447.0 },
      title: { en: 'Deir alla- zai', ar: 'دير علا - زي' },
      year: '2001',
      capacity: '10416r'
    },
    {
      id: 'wtp06',
      position: { x: 302.0, y: 849.0 },
      title: { en: 'GhorEs Safi', ar: 'غور الصافي' },
      year: '2005',
      capacity: '75'
    },
    {
      id: 'wtp07',
      position: { x: 343.0, y: 494.0 },
      title: { en: 'Karameh', ar: 'الكرامة' },
      year: '2008',
      capacity: '120'
    },
    {
      id: 'wtp08',
      position: { x: 357.0, y: 422.0 },
      title: { en: 'Abu Zeighan', ar: 'ابو الزيغان' },
      year: '2003',
      capacity: '1800'
    },
    {
      id: 'wtp09',
      position: { x: 343.0, y: 551.0 },
      title: { en: "Zara-Ma'in", ar: 'زارا ماعين' },
      year: '2008',
      capacity: '6270'
    }
  ]
}
